import { createSlice } from "@reduxjs/toolkit";

export const initialFeedbackState = () => ({
    formName: null,
    referringButtonId: "",
});
const feedbackSlice = createSlice({
    name: "feedback",
    initialState: initialFeedbackState(),
    reducers: {
        update_zendesk_form: {
            reducer: (state, action) => {
                return {
                    ...state,
                    formName: action.payload.formName,
                    referringButtonId: action.payload.referringButtonId,
                };
            },
            prepare: (payload) => {
                if (!payload) {
                    return { payload: initialFeedbackState() };
                }
                return {
                    payload: {
                        formName: payload.formName,
                        referringButtonId: payload.buttonId,
                    },
                };
            },
        },
    },
});

export const { update_zendesk_form } = feedbackSlice.actions;
export default feedbackSlice.reducer;
